export default "__VITE_ASSET__CvNev$XO__"